// Default location used by LocationPicker when no location is mentioned on URL
export const defaultLocation = {
  location: 'WILLVA',
  url: 'williamsburg'
};
